// @core/api/endpoints/billing/list_billing_accounts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBillingAccountsResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List billing accounts
 * Returns a paginated list of billing accounts with optional filtering by active or delinquent status.
 */
export async function ListBillingAccounts(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBillingAccountsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/billing-accounts`;
  const requestOptions = options;
  return client.get<ListBillingAccountsResponse>(requestPath, { ...requestOptions, params });
}
